<template>
  <div>

    <div class="vx-row mb-2">
      <div class="vx-col w-full">

        <b-button
          variant="outline-primary"
          type="submit"
          :class="['float-right']"
          @click="addNewOrganizationUnit"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          <span class="align-middle">Adicionar Nova Unidade</span>
        </b-button>

      </div>
    </div>

    <div class="vx-row" v-for="organizationalUnit in organizationalUnitList" :key="organizationalUnit">
        <div class="vx-col w-full">
          <OrganizationalUnit 
            :organizationalUnit="organizationalUnit" 
            :services="services"
            @destroy="destroyOrganizationalUnit"
          />
        </div>
    </div>
      
  </div>
</template>

<script>

import { 
  BButton, 
} from 'bootstrap-vue'
import OrganizationalUnit from './OrganizationalUnit.vue'

export default {
  directives: {
  },
  components: {
    BButton,
    OrganizationalUnit
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    legalEntityId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    organizationalUnitList: []
  }),
  computed: {
    
  },
  watch: {},
  methods: {
    organizationalUnitsList() {
      return this.organizationalUnitList
    },
    addNewOrganizationUnit() {

      const params = {
        legal_entity_id: this.legalEntityId
      }

      this.services.organizationalUnitService.create(params).then(data => {
        this.organizationalUnitList.unshift(data)
      }, error => {
        this.notifyError(this.$vs, 'Não foi possível criar unidade organizacional!')
      })
      
    },
    destroyOrganizationalUnit(organizationalUnit) {
      this.$vs.loading()
      this.services.organizationalUnitService
        .destroy({
          id: organizationalUnit.id
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.organizationalUnitList = this.organizationalUnitList.filter(element => {
              return element.id !== organizationalUnit.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
  },
  beforeMount() {
    
  },
  mounted() {
    
    this.$root.$on('legalEntityUpdated', () => {
      const legalEntity = this.$store.getters['legalEntity/legalEntity']
      if (legalEntity) {
        this.organizationalUnitList = legalEntity.organizational_units
      }
    })
  }
}
</script>